































import { Component, Model, Emit, Prop, Vue } from 'vue-property-decorator'
import HdsIcon from '@/components/HdsIcon.vue'
import HdsBtn from '@/components/HdsBtn.vue'

@Component({
  components: { HdsIcon, HdsBtn },
})
export default class HdsCheckbox extends Vue {
  /**
   *  레이블 텍스트 값입니다.
   */
  @Prop({ type: String, default: '' }) readonly label!: string

  /**
   * 기본 컬러 값입니다.
   *
   * 컬러코드나, tailwind theme에 해당하는 컬러 값을 사용 가능합니다.
   */
  @Prop({ type: String, default: 'primary' }) readonly color!: string

  /**
   * 레이블 컬러 값입니다.
   *
   * 컬러코드나, tailwind theme에 해당하는 컬러 값을 사용 가능합니다.
   */
  @Prop({ type: String, default: 'gray-700' }) readonly colorLabel!: string

  /**
   * OFF 상태 컬러 값입니다.
   *
   * 컬러코드나, tailwind theme에 해당하는 컬러 값을 사용 가능합니다.
   */
  @Prop({ type: String, default: 'gray-500' }) readonly colorOff!: string

  /**
   * 비활성화
   */
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Model('input', { type: Boolean, default: false }) readonly value!: boolean
  @Emit('input') onChange() {
    return !this.value
  }

  get d() {
    return this.value
      ? 'M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z'
      : 'M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z'
  }

  get containerClasses() {
    return {
      container: true,
      notranslate: true,
    }
  }

  get inputClasses() {
    return {
      input: true,
      notranslate: true,
      'cursor-pointer': !this.disabled,
      'cursor-not-allowed': this.disabled,
    }
  }

  get checkboxClasses() {
    return {
      checkbox: true,
      notranslate: true,
      [`text-${this.value ? this.color : this.colorOff}`]: !this.disabled,
      [`text-disabled`]: this.disabled,
      'cursor-pointer': !this.disabled,
      'cursor-not-allowed': this.disabled,
    }
  }

  get checkboxStyles() {
    return {
      color: this.value
        ? this.color.includes('#')
          ? this.color
          : ''
        : this.colorOff.includes('#')
        ? this.colorOff
        : '',
    }
  }

  get rippleClasses() {
    return {
      ripple: true,
      'ripple--center': true,
      [`text-${this.value ? this.color : this.colorOff}`]: true,
      'cursor-pointer': !this.disabled,
      'cursor-not-allowed': this.disabled,
    }
  }

  get rippleStyles() {
    return {
      color: this.value
        ? this.color.includes('#')
          ? this.color
          : ''
        : this.colorOff.includes('#')
        ? this.colorOff
        : '',
    }
  }

  get labelClasses() {
    return {
      label: true,
      [`text-${this.colorLabel}`]: true,
      'cursor-pointer': !this.disabled,
    }
  }

  get labelStyles() {
    return {
      color: this.colorLabel.includes('#') ? this.colorLabel : '',
    }
  }

  toggle() {
    if (this.disabled) return
    this.onChange()
  }
}
